export const DEFAULT_SETTINGS = {
  canRegister: false,
  canExternalProviders: true,
  canRemember: true,
  adminLogin: false
};

export const SETTINGS = {
  "visary-ui": {
    canExternalProviders: false,
    canRegister: true
  },
  client2: {
    canRegister: false,
    canExternalProviders: false,
    canRemember: false,
    adminLogin: true
  }
};

export const createSettings = (clientId) => ({
  ...DEFAULT_SETTINGS,
  ...SETTINGS[clientId]
});
